import { isDuplicatedLicenses, validateEmail, validateLicenses } from './common'
import { errorCodes, getUserFriendlyErrorMessage } from './errormessages'
import { editProviderProfileInfo } from '../store/accountSettings/AccountSettingsThunk'
import { setPhoneErrorAction } from '../store/waitingRoom/WaitingRoomActions'

export const prefixOptions = [' ', 'Dr.', 'Mr.', 'Mrs.', 'Ms.', 'Prof.']
export const suffixOptions = [' ', 'DO', 'LPC', 'MD', 'MPH', 'NP', 'PA', 'PhD', 'RN']
export const medicalProfessionOptions = [
  'Acupuncturist',
  'Addiction Medicine Physician',
  'Allergist',
  'Anesthesiologist',
  'Audiologist',
  'Bariatric Physician',
  'Cardiac Electrophysiologist',
  'Cardiologist',
  'Cardiothoracic Surgeon',
  'Certified Rehabilitation Counselor',
  'Chiropractor',
  'Colorectal Surgeon',
  'Dentist',
  'Dermatologist',
  'Dietitian',
  'Ear, Nose & Throat Doctor',
  'Emergency Medicine Physician',
  'Endocrinologist',
  'Endodontist',
  'Family Physician',
  'Gastroenterologist',
  'Geneticist',
  'Geriatrician',
  'Hand Surgeon',
  'Hematologist',
  'Immunologist',
  'Infectious Disease Specialist',
  'Integrative Health Medicine Specialist',
  'Internist',
  'Licensed Professional Counselor',
  'LPN',
  'Medical Assistant',
  'Medical Ethicist',
  'Microbiologist',
  'Midwife',
  'Naturopathic Doctor',
  'Nephrologist',
  'Neurologist',
  'Neuropsychiatrist',
  'Neurosurgeon',
  'Nurse Practitioner',
  'Nutritionist',
  'OB-GYN',
  'Occupational Medicine Specialist',
  'Oncologist',
  'Only Doctors Notes',
  'Ophthalmologist',
  'Optometrist',
  'Oral Surgeon',
  'Orthodontist',
  'Orthopedic Surgeon',
  'Pain Management Specialist',
  'Pathologist',
  'Pediatric Dentist',
  'Pediatrician',
  'Periodontist',
  'Physiatrist',
  'Physical Therapist',
  'Physician Assistant',
  'Plastic Surgeon',
  'Podiatrist',
  'Preventive Medicine Specialist',
  'Primary Care Doctor',
  'Prosthodontist',
  'Provider',
  'Psychiatrist',
  'Psychologist',
  'Psychosomatic Medicine Specialist',
  'Psychotherapist',
  'Pulmonologist',
  'Radiation Oncologist',
  'Radiologist',
  'Reproductive Endocrinologist',
  'Rheumatologist',
  'Sleep Medicine Specialist',
  'Social Worker',
  'Sports Medicine Specialist',
  'Surgeon',
  'Surgical Oncologist',
  'Travel Medicine Specialist',
  'Urgent Care Specialist',
  'Urological Surgeon',
  'Urologist',
  'Vascular Surgeon',
]

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const checkAllLicensesFields = (licensesArray, setLicensesArrayCallback) => {
  let issues = 0
  let licenseIssue = 0
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const newLicenseBlock = licensesArray.map((t) => {
    if (t.licenseServiceTypesDropdownValue.trim().length === 0 && !t.licenseNumberError) {
      issues += 1
      return {
        ...t,
        licenseServiceTypesDropdownValueError: true,
        licenseServiceTypesDropdownValueLocalError: getUserFriendlyErrorMessage(
          errorCodes.LICENSE_WITHOUT_ONE_SERVICE_TYPE,
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          null,
          'Service types',
        ),
      }
    }
    // @ts-expect-error TS2367 -- MIGRATION: not approved, fix when encountered
    if (!t.licenseServiceTypesDropdownValue.trim().length === 0 && t.licenseNumberError) {
      if (
        t.licenseNumberLocalError === '211 - Shared License.' ||
        t.licenseNumberLocalError === getUserFriendlyErrorMessage(errorCodes.LICENSE_INVALID)
      ) {
        licenseIssue += 3
      } else {
        licenseIssue += 1
      }
      return t
    }
    if (t.licenseServiceTypesDropdownValue.trim().length === 0 && t.licenseNumberError) {
      if (
        t.licenseNumberLocalError === '211 - Shared License.' ||
        t.licenseNumberLocalError === getUserFriendlyErrorMessage(errorCodes.LICENSE_INVALID)
      ) {
        licenseIssue += 3
      } else {
        licenseIssue += 1
      }

      return {
        ...t,
        licenseServiceTypesDropdownValueError: true,
        licenseServiceTypesDropdownValueLocalError: getUserFriendlyErrorMessage(
          errorCodes.LICENSE_WITHOUT_ONE_SERVICE_TYPE,
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          null,
          'Service types',
        ),
      }
    }
    if (t.licenseNumberLocalError === getUserFriendlyErrorMessage(errorCodes.LICENSE_INVALID)) {
      licenseIssue += 3
    }
    return t
  })
  setLicensesArrayCallback(newLicenseBlock)
  validateLicenses(newLicenseBlock, setLicensesArrayCallback)
  if (issues !== 0) {
    return issues !== 0
  }
  if (licenseIssue >= 2) {
    return licenseIssue >= 2
  }
}

export const onClickSafeMemberButton = (
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  dispatch,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setPageErrorCallback,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  firstNameState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setFirstNameLocalErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setFirstNameErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  lastNameState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setLastNameLocalErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setLastNameErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  emailState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setEmailLocalErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setEmailErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  prefixState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  suffixState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  roleState,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setRoleLocalErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setRoleErrorCallBack,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  professionalTitle,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setProfessionalTitleError,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setProfessionalTitleLocalError,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  licensesArray,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setLicensesArray,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  isImageChanged,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  tabId,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  timeZone,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  phoneCountryCode,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  phoneNumber,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  phoneCountry,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  isPhoneValid,
) => {
  let hasErrors = false // Added hasErrors variable

  // Determine if the phone number is invalid and not empty
  const isPhoneNumberInvalid = phoneNumber && !isPhoneValid

  if (
    firstNameState.trim() === '' ||
    (professionalTitle.trim() === '' && roleState === 'Provider') ||
    lastNameState.trim() === '' ||
    emailState.trim() === '' ||
    validateEmail(emailState) === null ||
    isPhoneNumberInvalid // Include phone number validation
  ) {
    hasErrors = true // Set hasErrors to true if validation fails

    const validationConditions = {
      firstName: firstNameState.trim() === '',
      professionalTitle: roleState === 'Provider' && professionalTitle.trim() === '',
      lastName: lastNameState.trim() === '',
      email: emailState.trim() === '',
      emailValid: validateEmail(emailState) === null,
      phoneNumberInvalid: isPhoneNumberInvalid,
    }
    const failedConditions = Object.keys(validationConditions).filter((key) => validationConditions[key])
    const errorCount = failedConditions.length
    const onlyPhoneNumberError = errorCount === 1 && validationConditions.phoneNumberInvalid

    // Count the number of failed conditions

    if (!onlyPhoneNumberError) {
      // Dispatch the general error message only if:
      // - There are multiple errors, or
      // - The sole error is not the phone number invalidation
      console.log('fghjkl')
      dispatch(setPageErrorCallback(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)))
    }

    if (firstNameState.trim() === '') {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setFirstNameLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'First name'))
      setFirstNameErrorCallBack(true)
    }
    if (professionalTitle.trim() === '' && roleState === 'Provider') {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setProfessionalTitleLocalError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Professional title'))
      setProfessionalTitleError(true)
    }
    if (lastNameState.trim() === '') {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setLastNameLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Last name'))
      setLastNameErrorCallBack(true)
    }
    if (roleState.trim() === '') {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setRoleLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Role'))
      setRoleErrorCallBack(true)
    }
    if (
      (checkAllLicensesFields(licensesArray, setLicensesArray) || isDuplicatedLicenses(licensesArray)) &&
      roleState === 'Provider'
    ) {
      checkAllLicensesFields(licensesArray, setLicensesArray)
    }
    if (validateEmail(emailState) === null) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setEmailLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Email'))
      setEmailErrorCallBack(true)
    }
    if (emailState.trim() === '') {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setEmailLocalErrorCallBack(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Email'))
      setEmailErrorCallBack(true)
    }

    // Handle phone number error if invalid
    if (isPhoneNumberInvalid) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setPhoneErrorAction(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')))
    }
  } else {
    // Proceed to dispatch action
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    setLicensesArray(licensesArray.map((t) => ({ ...t, licenseNumberError: false, licenseNumberLocalError: '' })))

    if (roleState === 'Provider') {
      // Set PhoneNumber to null if empty or create the phone object if not
      const phoneNumberObject =
        phoneNumber && phoneNumber.trim() !== '' ?
          {
            CountryCode: phoneCountry.toUpperCase(),
            Prefix: `+${phoneCountryCode}`,
            Number: `+${phoneCountryCode}${phoneNumber}`,
          }
        : null // Phone number is null if not provided

      const editMemberProviderBody = {
        FirstName: firstNameState,
        LastName: lastNameState,
        Prefix: prefixState?.trim(),
        Suffix: suffixState?.trim(),
        TimeZone: timeZone,
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        ProfessionalTitles: professionalTitle.split(';').map((t) => t.trim()),
        PhoneNumber: phoneNumberObject, // Set to null if no phone number
      }
      console.log('editMemberProviderBody', editMemberProviderBody)
      dispatch(editProviderProfileInfo(editMemberProviderBody, isImageChanged ? 'withImg' : 'withOutImg', tabId))
    }
  }

  if (hasErrors) {
    return false // Return false if there are validation errors
  }
  return true // Return true if validation passed and action dispatched
}
